// Import: Middleware Action & Custom Types
import { CLEAN_REMOVE_LINE, CLEAN_REMOVE_LINE_ERROR } from '_models/redux/types';

// Action function
export const cleanRemoveLine = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_REMOVE_LINE,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_REMOVE_LINE_ERROR,
    });
  }
};
